// ============================================================================
// ADMIN USERS — ACCESS HOOKS (grant / revoke employee & client access)
// ============================================================================
//
// This module is now a thin re-export of the CANONICAL access hooks in
// `lib/hooks/api/admin/sections/{employee-access,client-access}.ts`.
//
// It previously held a DUPLICATE, BUGGY implementation:
//   - useGrantEmployeeAccess inserted `employee_id` + `granted_at` into
//     employee_contact_access — neither column exists (verified schema:
//     id, user_id, contact_id, created_at, granted_by) → every employee grant
//     failed at the database.
//   - useGrantClientAccess inserted without the upsert/dedup guard the
//     canonical client-access hook provides.
//
// Both are now the single canonical source so every importer (admin user
// modals via useGrantAccessMutationHook, the user-centric grant modals, and
// anything reaching them through `@/lib/hooks/use-api`) shares one correct
// code path against the real schema.

export {
  useGrantEmployeeAccess,
  useRevokeEmployeeAccess,
} from "@/lib/hooks/api/admin/sections/employee-access";

export {
  useGrantClientAccess,
  useRevokeClientAccess,
  useClientUserAccess,
} from "@/lib/hooks/api/admin/sections/client-access";
